<template>
  <!-- :style="{'min-height': docHt + 'px'}" -->
   <div class="wrapper">
      <HeaderNav title="设置行业" v-if="!isMobile"></HeaderNav>
      <a href="https://developers.weixin.qq.com/miniprogram/product/material/#%E9%9D%9E%E4%B8%AA%E4%BA%BA%E4%B8%BB%E4%BD%93%E5%B0%8F%E7%A8%8B%E5%BA%8F%E5%BC%80%E6%94%BE%E7%9A%84%E6%9C%8D%E5%8A%A1%E7%B1%BB%E7%9B%AE" target="_blank" class="jump-link">
        点击查看所属行业需提供的资质>
      </a>
      <div class="container">
        <div class="items" v-for="(item, index) in categories" :key="index">
          <div class="input-group input-group-category">
            <div class="col">
              <h5>所属行业大类</h5>
              <el-select v-model="item.first" placeholder="请选择" @change="categoryChange(item,index)">
                <el-option
                  v-for="fItem,fIndex in industryList"
                  :key="fIndex"
                  :label="fItem.name"
                  :value="fItem.id">
                </el-option>
              </el-select>
            </div>
            <div class="col">
              <h5>所属行业子类</h5>
              <el-select v-model="item.second" placeholder="请选择">
                <el-option
                  v-for="sItem,sIndex in item.subCategoryOptions"
                  :key="sIndex"
                  :label="sItem.name"
                  :value="sItem.id">
                </el-option>
              </el-select>
            </div>
            <span class="iconfont icon-delete" @click="deleteIndustry(index)"></span>
          </div>
          <div class="section">
            <h5>资质上传</h5>
            <VantWecahtUploadImg :shopCode="shopCode" :value="item.files" :limit="5" @valChange="getCerticatesImages($event,index)" class="avatar" />
          </div>
        </div>
        <div class="add-btn" @click="addIndustry">
          <span class="iconfont icon-add2"></span>添加
        </div>
     </div>
     <div class="footer-bar"></div>
     <div class="footer footer-btns">
       <div class="submit-btn" @click="onSubmitIndustry">提交</div>
       <router-link :to="{path: '/set-auth?shopCode='+shopCode}" class="jump-btn">跳过</router-link>
     </div>
   </div>
 </template>
 
<script>
  import VantWecahtUploadImg from '@/components/VantWecahtUploadImg.vue';
  import { wxSetting, wxGetCategory, getCategoryParentList, getCategoryChildList, addCategory,getSettingCategories ,manageApplyPlugin} from '@/api/register';
  export default {
    components: {
      VantWecahtUploadImg: VantWecahtUploadImg,
    },
    data () {
      return {
        isMobile: false,
        docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
        shopCode: null,
        images: '',
        form: {
          name: '',
          appId: '',
          originalId: '',
          keyWord: '',
          desc: '',
          avatar: ''
        },
        categories: [{
          first: null,
          second: null,
          certicates:[],
          files:''
        }],
        industryList: [],
        subCategoryOptions: [],
      }
    },
    created() {
      if(this.$route.query){
        this.shopCode = this.$route.query.shopCode;
      }
      this.mobileTerminal((data) => {
        this.isMobile = data
      })
      this.getCategoryParentList();
      this.getSettingCategories();
    },
    methods: {
      getSettingCategories(){
        getSettingCategories({shopCode:this.shopCode}).then(res=>{
          if(res.data&&res.data.categories&&res.data.categories.length>0){
            this.categories = [];
            res.data.categories.forEach((item,index)=>{
              item.filesArr = [];
              if(item.certicates&&item.certicates.length>0){
                item.certicates.forEach(item=>{
                  item.filesArr.push({
                    name:item.key,
                    url:item.value
                  })
                })
              }
              this.categories.push({
                first: String(item.first),
                second: String(item.second),
                certicates: item.certicates?item.certicates:[],
                files: item.filesArr&&item.filesArr.length>0?item.filesArr.join(','):'',
                subCategoryOptions:[]
              })
              this.getCategoryChildList(item.first, index);
            })
          } else {
            this.categories = [];
          }
        })
      },
      getCategoryParentList(){
        getCategoryParentList({shopCode:this.shopCode}).then(res=>{
          this.industryList = res.data;
        })
      },
      getCategoryChildList(parentId,index){
        getCategoryChildList({'parentId':parentId,shopCode:this.shopCode}).then(res=>{
          if(res.data&&res.data.length>0){
            this.categories[index].subCategoryOptions = res.data[0].children||[];
          } else {
            this.categories[index].subCategoryOptions = [];
          }
          this.$forceUpdate();
        })
      },
      categoryChange(item,index){
        if(item.subCategoryOptions&&item.subCategoryOptions.length>0){
          if(item.subCategoryOptions.filter(v=>{return v.parentId!==item.first}).length>0){
            item.second = null;
            item.subCategoryOptions = [];
            this.getCategoryChildList(item.first,index);
          }
        } else {
          item.second = null;
          item.subCategoryOptions = [];
          this.getCategoryChildList(item.first,index);
        }
      },
      addIndustry() {
        if(this.categories.length>=5) return this.Toast('最多设置5种行业~');
        this.categories.push({
          first: null,
          second: null,
          certicates:[],
          files:''
        })
      },
      deleteIndustry(index) {
        if(this.categories.length<=1) return false;
        this.categories.splice(index, 1);
      },
      getCerticatesImages(files,index) {
        let filesArr = [];
        filesArr = files?files.split(','):[];
        if(filesArr&&filesArr.length>0){
          filesArr.forEach(item=>{
            this.categories[index].certicates.push({
              key: '',
              value: item
            })
          })
        }
      },
      onSubmitIndustry(){
        let categories = [];
        if(this.categories.length<1||this.categories.length>0&&this.categories.findIndex(v=>{return !v.first||!v.second})!==-1) return this.Toast('请设置行业~');
        this.categories.forEach(item=>{
          categories.push({
            first: item.first,
            second: item.second,
            certicates: item.certicates,
          })
        })
        addCategory({'categories': categories},this.shopCode).then(res => {
          if(res.code === 200) {
            setTimeout(() => {
              this.$router.push({
                path: '/set-auth?shopCode=' + this.shopCode
              })
            }, 1500)
          } else {
            this.Toast(res.msg);
          }
        })
      }
    }
  }
</script>
 
 <style lang="scss" scoped>
 @media screen and (max-width:750px){
  .container{
    padding-bottom: 1.5rem;
  }
   .input-group, .section{
     width: 16.7rem;
     margin: 0 auto 1.2rem;
     h5{
       margin-bottom: .4rem;
       font-size: .7rem;
       color: #666;
       font-weight: 400;
     }
     /deep/ .el-input__inner, /deep/ .el-textarea__inner{
       border-radius: .5rem;
       border: 1px solid #ddd;
       font-size: .8rem;
       color: #222;
     }
     /deep/ .el-textarea__inner{
       padding: .3rem .5rem;
     }
     /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
       font-size: .8rem;
     }
     /deep/ .el-input__inner{
       height: 2.4rem;
       padding: 0 .5rem;
     }
   }
   .avatar{
     background: #f5f5f9;
   }
   .input-group-category{
     display: flex;
     justify-content: space-between;
     .col{
      width: 7.5rem;
      margin-right: .5rem;
     }
     .icon-delete{
      width: 1rem;
      height: 2.4rem;
      line-height: 2.4rem;
      font-size: 1rem;
      color: #5E7A99;
      margin-top: 1.2rem;
      cursor: pointer;
     }
   }
   .add-btn{
    display: flex;
    align-items: center;
    margin: 0 1rem;
    font-size: .7rem;
    color: #47B6C7;
    cursor: pointer;
    .icon-add2{
      font-size: 1rem;
      margin-right: .2rem;
    }
   }
   .app-id-box{
     width: 100%;
     display: flex;
     cursor: pointer;
     .input-app-id{
       width: 12.3rem;
       height: 2.4rem;
       border-radius: .5rem 0 0 .5rem;
       border: 1px solid #ddd;
       position: relative;
       @include flex(space-between);
       @include text-overflow();
       /deep/ .el-input__inner{
         border: 0;
       }
     }
     .btn{
         width: 4.4rem;
         height: 2.4rem;
         border-radius: 0 .5rem .5rem 0;
         border: 1px solid #ddd;
         border-left: 0;
         @include flex();
         font-size: .7rem;
         color: #47B6C7;
       }
   }
   .submit-btn{
     width: 8.1rem;
     height: 2.2rem;
     line-height: 2.15rem;
     background: #47B6C7;
     border-radius: .5rem;
     font-size: .8rem;
     color: #fff;
     text-align: center;
     margin: 0;
     // margin: 2.1rem auto 1.5rem;
   }
   .jump-btn{
     line-height: 1.4;
     font-size: .8rem;
     color: #47B6C7;
     text-align: center;
     display: block;
     margin-left: .6rem;
   }
   .footer{
     box-shadow: 0px -5px 5px #eee;
   }
 }
 @media screen and (min-width:750px){
   .container{
     height: 70vh;
     padding-bottom: 30px;
   }
   .input-group, .section{
     width: 334px;
     margin: 0 auto 24px;
     h5{
       margin-bottom: 8px;
       font-size: 14px;
       color: #666;
       font-weight: 400;
     }
     /deep/ .el-input__inner, /deep/ .el-textarea__inner{
       border-radius: 10px;
       border: 1px solid #ddd;
       font-size: 16px;
       color: #222;
     }
     /deep/ .el-textarea__inner{
       padding: 6px 10px;
     }
     /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
       font-size: 16px;
     }
     /deep/ .el-input__inner{
       height: 48px;
       padding: 0 10px;
     }
   }
   .input-group-category{
     display: flex;
     justify-content: space-between;
     .col{
       width: 150px;
       margin-right: 10px;
     }
     .icon-delete{
      width: 20px;
      height: 48px;
      line-height: 48px;
      font-size: 20px;
      color: #5E7A99;
      margin-top: 24px;
      cursor: pointer;
     }
   }
   .add-btn{
    display: flex;
    align-items: center;
    margin: 0 20px;
    font-size: 14px;
    color: #47B6C7;
    cursor: pointer;
    .icon-add2{
      font-size: 20px;
      margin-right: 4px;
    }
   }
   .app-id-box{
     width: 100%;
     display: flex;
     cursor: pointer;
     .input-app-id{
       width: 246px;
       height: 48px;
       border-radius: 10px 0 0 10px;
       border: 1px solid #ddd;
       position: relative;
       @include flex(space-between);
       @include text-overflow();
       /deep/ .el-input__inner{
         border: 0;
       }
     }
     .btn{
         width: 88px;
         height: 48px;
         border-radius: 0 10px 10px 0;
         border: 1px solid #ddd;
         border-left: 0;
         @include flex();
         font-size: 14px;
         color: #47B6C7;
       }
   }
   .submit-btn{
     width: 162px;
     height: 44px;
     line-height: 43px;
     background: #47B6C7;
     border-radius: 10px;
     font-size: 16px;
     color: #fff;
     text-align: center;
     margin: 0;
     // margin: 42px auto 30px;
   }
   .jump-btn{
     line-height: 1.4;
     font-size: 16px;
     color: #47B6C7;
     text-align: center;
     display: block;
     margin-left: 12px;
   }
   .footer{
     position: fixed;
     bottom: auto;
   }
 }
.footer-btns{
  display: flex;
  align-items: center;
  justify-content: center;
}
.jump-link{
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 12px 0;
  font-size: 14px;
  color: #47B6C7;
  text-align: left;
  display: block;
  background: #fff;
}
 </style>


// WEBPACK FOOTER //
// src/views/set-industry.vue